import { AlertTriangle, X } from 'lucide-react';
import { useDeleteTicket } from '../hooks/useDeleteTicket';

export const DeleteConfirmModal = (props) => {
  const { isDeleteModalOpen, setIsDeleteModalOpen, ticket } = props;
  const { mutate: deleteTicket, isPending } = useDeleteTicket();

  if (!isDeleteModalOpen || !ticket) return null;

  const handleDelete = () => {
    deleteTicket(ticket._id, {
      onSuccess: () => {
        setIsDeleteModalOpen(false);
      },
    });
  };

  return (
    <div className='fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4'>
      <div className='bg-card border border-border rounded-lg w-full max-w-md'>
        {/* Header */}
        <div className='px-6 py-4 border-b border-border flex items-center justify-between'>
          <div className='flex items-center space-x-2'>
            <AlertTriangle className='text-destructive' size={20} />
            <h2 className='text-lg font-semibold'>Delete Ticket</h2>
          </div>
          <button onClick={() => setIsDeleteModalOpen(false)} className='p-1 hover:bg-muted rounded-md transition-colors'>
            <X size={20} />
          </button>
        </div>

        {/* Content */}
        <div className='p-6 space-y-4'>
          <p className='text-sm text-muted-foreground'>
            Are you sure you want to delete this ticket? This action cannot be undone.
          </p>

          <div className='bg-muted rounded-lg p-4 space-y-2'>
            <p className='text-xs font-medium text-muted-foreground uppercase'>Ticket Details</p>
            <div className='space-y-1 text-sm'>
              <p>
                <span className='font-medium'>Ticket Number:</span> {ticket.ticketNumber}
              </p>
              <p>
                <span className='font-medium'>Subject:</span> {ticket.subject}
              </p>
              <p>
                <span className='font-medium'>Status:</span> {ticket.status?.replace(/_/g, ' ')}
              </p>
              <p>
                <span className='font-medium'>Customer:</span> {ticket.customerId?.firstName}{' '}
                {ticket.customerId?.lastName}
              </p>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className='flex justify-end space-x-3 px-6 py-4 border-t border-border'>
          <button
            onClick={() => setIsDeleteModalOpen(false)}
            className='px-4 py-2 text-sm border border-border rounded-md hover:bg-accent transition-colors'
          >
            Cancel
          </button>
          <button
            onClick={handleDelete}
            disabled={isPending}
            className='px-4 py-2 text-sm bg-destructive text-destructive-foreground rounded-md hover:bg-destructive/90 transition-colors disabled:opacity-50'
          >
            {isPending ? (
              <div className='flex items-center justify-center'>
                <div className='animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2' />
                Deleting...
              </div>
            ) : (
              'Delete Ticket'
            )}
          </button>
        </div>
      </div>
    </div>
  );
};
